/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileZipEndpointRequest
 */
export interface FileZipEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileZipEndpointRequest
     */
    input: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FileZipEndpointRequest
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof FileZipEndpointRequest
     */
    name: string;
}

export function FileZipEndpointRequestFromJSON(json: any): FileZipEndpointRequest {
    return FileZipEndpointRequestFromJSONTyped(json, false);
}

export function FileZipEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileZipEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'path': json['path'],
        'name': json['name'],
    };
}

export function FileZipEndpointRequestToJSON(value?: FileZipEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'path': value.path,
        'name': value.name,
    };
}


